import { NgModule } from '@angular/core';
import { ModalFormHostServiceModule } from './modal-form-host-service/modal-form-host-service.module';
import { ModalFormHostModule } from './modal-form-host/modal-form-host.module';

@NgModule({
  imports: [
    ModalFormHostModule,
    ModalFormHostServiceModule
  ],
  exports: [
    ModalFormHostModule,
    ModalFormHostServiceModule
  ]
})
export class ModelFormHostExModule { }
